/**
 * Gets the actions registered for the route.
 * @param routeIdentifier - Identifier of the route.
 * @returns Actions registered for the route, or null if the route identifier is not provided or the actions are not available.
 */
export function getAction(routeIdentifier) {
    var _a, _b, _c;
    if (!routeIdentifier)
        return null;
    return ((_c = (_b = (_a = window.SYDLE) === null || _a === void 0 ? void 0 : _a.router) === null || _b === void 0 ? void 0 : _b.actions) === null || _c === void 0 ? void 0 : _c[routeIdentifier]) || null;
}
